import { render } from "./IVShowCasePage.vue?vue&type=template&id=4c11ec4c&scoped=true&ts=true"
import script from "./IVShowCasePage.vue?vue&type=script&lang=ts"
export * from "./IVShowCasePage.vue?vue&type=script&lang=ts"

import "./IVShowCasePage.vue?vue&type=style&index=0&id=4c11ec4c&lang=scss&scoped=true"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c11ec4c"]])

export default __exports__